import React, { useState, useContext, useEffect } from "react";
import SummaryView from "./SummaryView/SummaryView";
import { useRouteMatch,useLocation, Route, useParams } from "react-router-dom";
import DataView from "./DataView/DataView";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { ToggleButton } from "../../ui/ToggleButton";
import { ScorecardIcon } from "../../assets/svg/ScorecardIcon";
import { CircleIcon } from "../../assets/svg/CircleIcon";
import { Button } from "../../ui/Button";
import Modal from "../../ui/Modal";
import { UpdateMeasures } from "../dashboard/UpdateMeasures";
import { get } from "../../utils/get";
import { GetHook } from "../../api/api";
import { SCORECARD_URL } from "../../api/urls";
import { BASE_API_URL } from "../../utils/app-constants";
import moment from "moment";
import { AuthContext } from "../../context/AuthContext";
import { PerpectiveSubject } from "../../subjects/PerspectiveSubject";
import { DateContext } from "../../context/DateFilterContext";

const PerspectiveView = ({ scorecard}: any) => {
  const [dateFilter, setDateFilter] = useState("");
  const { path } = useRouteMatch();
  const location = useLocation();
  const params = useParams();
  const auth = useContext(AuthContext);
  // const [dateFilterState, setDateFilterState] = useContext(DateContext)

  const { user } = get(auth, "authState");  

  const date =
    get(dateFilter, "startDate") && get(dateFilter, "endDate")
      ? `interval=2024-01-01/2024-12-31`
      : "";

  

  let { data: objectivesData } = GetHook(
    get(params, "scorecard_id") && get(params, "perspective_id") && date
      ? `${SCORECARD_URL}/${get(
          params,
          "scorecard_id"
        )}/objective?perspective_id=${get(params, "perspective_id")}`
      : "null"
  );

  //removed interval
 
  let { data: kpis } = GetHook(
    get(params, "scorecard_id") && get(params, "perspective_id") && date
      ? `${SCORECARD_URL}/${get(
          params,
          "scorecard_id"
        )}/kpi?perspective_id=${get(params, "perspective_id")}`
      : "null"
  );

  let { data: perspectiveData } = GetHook(
    date
      ? `${SCORECARD_URL}/${get(params, "scorecard_id")}/perspective?perspective_id=${get(
          params,
          "perspective_id"
        )}`
      : "null"
  );

  const { data: comments } = GetHook(
    get(perspectiveData, "[0]id")
      ? `${BASE_API_URL}/scorecardperspective/${get(
          perspectiveData,
          "[0]id"
        )}/comment`
      : "null"
  );

  useEffect(() => {
    PerpectiveSubject.next(perspectiveData);
  }, [perspectiveData]);

  const indicatorData = objectivesData.map((obj) => {
    return {
      name: get(obj, "objective_name"),
      weight: get(obj, "weight"),
      score: get(obj, "periodic_score"),
      weighted_score: get(obj, "weighted_periodic_score"),
    };
  });


  
  const summaryData = {
    name: get(scorecard, "[0]display_name", "-"),
    target: get(scorecard, "[0]target"),
    weight: get(scorecard, "[0]weight"),
    maxScore: get(scorecard, "[0]max_score"),
    minScore: get(scorecard, "[0]min_score"),
    baseLine: get(scorecard, "[0]baseline"),
    score: get(scorecard, "[0]weighted_periodic_score"),
    optimization: get(scorecard, "[0]optimisation"),
    type: get(scorecard, "[0]perspective.perspective_type"),
    scoreType: get(scorecard, "[0]perspective.score_type"),
    operatingScore:get(scorecard, "[0]weighted_periodic_score"),
    comments: get(scorecard, "[0]comments", []),
    // variance: get(scorecard, "[0]periodic_variance", []),
    status: get(scorecard, "[0]status", []),
  };

  const data = {
    name: get(perspectiveData, "[0]perspective_name", "-"),
    target: get(perspectiveData, "[0]target"),
    weight: get(perspectiveData, "[0]weight"),
    maxScore: get(perspectiveData, "[0]max_score"),
    minScore: get(perspectiveData, "[0]min_score"),
    baseLine: get(perspectiveData, "[0]baseline"),
    score: get(perspectiveData, "[0]periodic_score"),
    optimization: get(perspectiveData, "[0]optimisation"),
    type: get(perspectiveData, "[0]perspective.perspective_type"),
    scoreType: get(perspectiveData, "[0]perspective.score_type"),
    weighted_score: get(perspectiveData, "[0]weighted_periodic_score"),

    operatingScore: get(perspectiveData, "[0]periodic_score"),
    comments: comments && comments,
    // variance: get(perspectiveData, "[0]periodic_variance", 0),
  };

   
  const [isUpdateMeasuresModal, setUpdateMeasuresModal] = useState(false);
  return (
    <>
      <PerspectiveViewContainer>
        <Header>
        <TitleText>
          <span style={{ fontSize: 14, color: "#214160", opacity: 0.5 , marginBottom: 10}}>
          {summaryData?.name}
          <CardLabel
          color={
            get(summaryData, "status", "") === "active" ? "#0eab64" :  "#222222"
          }
          backgroundColor={
            get(summaryData, "status", "") === "active" ? "#b7f7e6" :  "#c4c4c4"
          }
          style={{ marginLeft: 10 }} 
          disabled ={true}
          >
          <TitleText
          style={{ fontSize: 15 , paddingLeft: 12 , paddingRight: 12}} 
          
          >
          {summaryData?.status}
          </TitleText>
          </CardLabel>
          </span>
          Perspective Overview
            
            </TitleText>

          <span>
            <ToggleButton
              url2="data"
              url1="summary"
              ButtonData2={{ label: "Data", icon: ScorecardIcon }}
              ButtonData1={{ label: "Summary", icon: CircleIcon }}
            />
            {get(scorecard, "[0]owner_id") === get(user, "id") && (
              <Button
                text="Update measures."
                onClick={() => setUpdateMeasuresModal(true)}
              />
            )}
          </span>
        </Header>
        <>
          <Route
            exact
            path={`${path}summary`}
            render={() => (
              <SummaryView
              selectedScorecard={scorecard}
                title="Perspective"
                data={data}
                indicatorTitle="Objectives"
                indicatorData={indicatorData}
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
              />
            )}
          />
          <Route
            exact
            path={`${path}data`}
            render={() => (
              <DataView
                title="Perspective"
                data={kpis}
                name={data?.name}
                setDateFilter={setDateFilter}
                objectives={objectivesData}
              />
            )}
          />
        </>
      </PerspectiveViewContainer>
      {isUpdateMeasuresModal && (
        <Modal
          width="90%"
          closeModal={() => setUpdateMeasuresModal(false)}
          title=""
          handleSubmit={() => null}
          noFooter
        >
          <TitleText> Update measures  
          <span style={{ fontSize: 14, color: "#214160", opacity: 0.5}}>
          - {summaryData?.name}
          </span>
           </TitleText>
          <UpdateMeasures />
        </Modal>
      )}
    </>
  );
};

export default PerspectiveView;

const PerspectiveViewContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  padding: 3.3em 1em;
  span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CardLabel = styled.button<{
  backgroundColor: string;
  color: string;
}>`
border-radius: 0.5em;
display: grid;
align-items: center;
background-color: ${(props) => props.backgroundColor};
border-color: ${(props) => props.color};
${TitleText} {
  color: ${(props) => props.color};
  text-align: center;
  font-size: 12px;
  text-transform: capitalize;
}
`;
